import React from "react";

const JaugeCell = ({healthGuarantees, healthType}) => {

    let mandatoryLevel, optionalLevel;

    switch (healthType) {
        case 'routineCare':
            mandatoryLevel = parseInt(healthGuarantees?.healthBenefit.routineCareMandatoryLevel);
            optionalLevel = parseInt(healthGuarantees?.healthBenefit.routineCareOptionalLevel);
            break;
        case 'hospitalization':
            mandatoryLevel = parseInt(healthGuarantees?.healthBenefit.hospitalizationMandatoryLevel);
            optionalLevel = parseInt(healthGuarantees?.healthBenefit.hospitalizationOptionalLevel);
            break;
        case 'dental':
            mandatoryLevel = parseInt(healthGuarantees?.healthBenefit.dentalMandatoryLevel);
            optionalLevel = parseInt(healthGuarantees?.healthBenefit.dentalOptionalLevel);
            break;
        case 'optical':
            mandatoryLevel = parseInt(healthGuarantees?.healthBenefit.opticalMandatoryLevel);
            optionalLevel = parseInt(healthGuarantees?.healthBenefit.opticalOptionalLevel);
            break;
    }


    const mandatoryRows = [];
    for (let index = 1; index <= 6; index++) {
        if (index <= mandatoryLevel) {
            mandatoryRows.push(<img key={index} src="/o/mutelios-theme-css/icons/RectangleBleu.svg" alt=""/>);
        } else {
            mandatoryRows.push(<img key={index} src="/o/mutelios-theme-css/icons/RectangleTransparent.svg" alt=""/>);
        }
    }

    const optionalRows = [];
    if(!isNaN(optionalLevel)) {
        for (let index = 1; index <= 6; index++) {
            if (index <= optionalLevel) {
                optionalRows.push(<img key={index} src="/o/mutelios-theme-css/icons/RectangleOrange.svg" alt=""/>);
            } else {
                optionalRows.push(<img key={index} src="/o/mutelios-theme-css/icons/RectangleTransparent.svg" alt=""/>);
            }
        }
    }

    return (
        healthGuarantees ?
            <div
                className="tw-flex tw-h-[114px] tw-flex-col tw-justify-center tw-items-center tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
                <div className="tw-flex tw-flex-col tw-px-6 tw-justify-center tw-self-stretch">
                                <span
                                    className="tw-text-body tw-text-mutelios-txt-color-sec tw-self-stretch tw-h-[20px]">{`Obligatoire : ${mandatoryLevel}/6`}</span>
                    <div className="tw-flex tw-py-2 tw-gap-1 tw-self-stretch">
                        {mandatoryRows}
                    </div>
                </div>
                {!isNaN(optionalLevel) && (<div className="tw-flex tw-flex-col tw-px-6 tw-justify-center tw-self-stretch">
                                <span
                                    className="tw-text-body tw-text-mutelios-txt-color-sec tw-self-stretch tw-h-[20px]">{`Facultatif : ${optionalLevel}/6`}</span>
                    <div className="tw-flex tw-py-2 tw-gap-1 tw-self-stretch">
                        {optionalRows}
                    </div>
                </div>)}
            </div>
            : <div
                className="tw-flex tw-h-[114px] tw-p-3 tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
                <span className="tw-text-body-lead-bold tw-text-mutelios-txt-color">-</span>
            </div>
    );
}

export default JaugeCell;
